var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.483 10.974a.823.823 0 0 1-1.164 0L.927 6.582a.824.824 0 0 1 0-1.164l4.392-4.392A.824.824 0 0 1 6.483 2.19L3.497 5.176h8.992a.823.823 0 1 1 0 1.647H3.497L6.483 9.81a.824.824 0 0 1 0 1.164Z",
    fill: "currentColor"
  })));
};
export default SvgArrowBack;